import styled from "@emotion/styled";
import { Card, Col, Typography } from "antd";
import React from "react";
import { NumericFormat } from "react-number-format";

const ProductByAgentCard = () => {
  return (
    <>
      <Col
        xs={{ span: 12 }}
        sm={{ span: 12 }}
        md={{ span: 8 }}
        lg={{ span: 8 }}
        xl={{ span: 6 }}
        xxl={{ span: 4  }}
        style={{ width: "100%" }}
      >
        <Card
          
          style={{ width: "100%" }}
          cover={
            <img
              alt="example"
              src="https://bangbowblobdev.blob.core.windows.net/products/กยสอันโต.jpg"
            />
          }
        >
          <CardFooter>
            <Typography.Text className="text-order-product-name">
              {"ข้าวกระยาสารท"}
            </Typography.Text>
            <Typography.Text className="text-order-product-name">
              {"รายละเอียดสินค้า..."}
            </Typography.Text>
            <Typography.Text className="text-order-product-price">
              ราคา : ฿
              {
                <NumericFormat
                  value={500}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              }
            </Typography.Text>
            <Typography.Text className="text-order-product-price-retail">
              ราคาขายร้านค้า : ฿
              {
                <NumericFormat
                  value={500}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              }
            </Typography.Text>
          </CardFooter>
        </Card>
      </Col>
    </>
  );
};

export default ProductByAgentCard;

const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 5px 5px 10px 5px;
`;
